/**
 * 発行済み書類の確定PDF（発行時にR2へ保存されたもの）を取得してブラウザに保存させる。
 * 発行時のPDF確定に失敗していた過去データは 404 になるため、その場合のみ初回生成に
 * フォールバックする（DocumentPage の fetchIssuedPdf と同じ規則）。
 * 成功/失敗のトースト表示は呼び出し側で行う。
 */
import { documentsApi } from "../api.js";

export async function downloadIssuedPdf(docId: string, docNumber: string | null): Promise<string> {
  let blob: Blob;
  try {
    blob = await documentsApi.getPdf(docId);
  } catch {
    blob = await documentsApi.generatePdf(docId);
  }
  const filename = `${docNumber ?? docId}.pdf`;
  const url = URL.createObjectURL(blob);
  Object.assign(document.createElement("a"), { href: url, download: filename }).click();
  URL.revokeObjectURL(url);
  return filename;
}
